import React from "react";

// Read-only SVG diagram viewer. viewBox 0 0 500 300 matches the editor.
const YARD_LINES = Array.from({ length: 9 }, (_, i) => 50 + i * 50);
const OFFENSE_KINDS = ["QB", "RB", "WR", "TE"];

const palette = (printMode) => printMode
  ? { offense: "#111827", defense: "#374151", route: "#111827", field: "#f8fafc", yard: "#d1d5db",
      sideline: "#111827", sidelineOpacity: 0.6, los: "#111827", dotFill: "#ffffff", marker: "arrow-print" }
  : { offense: "#F59E0B", defense: "#10B981", route: "#FBBF24", field: "#052e16", yard: "#065f46",
      sideline: "#ffffff", sidelineOpacity: 0.4, los: "#F8FAFC", dotFill: "#0B0D12", marker: "arrow-screen" };

function PositionMark({ p, c }) {
  const color = p.kind === "O" || OFFENSE_KINDS.includes(p.kind) ? c.offense : c.defense;
  if (p.kind === "X") {
    return (
      <g>
        <line x1={p.x-5} y1={p.y-5} x2={p.x+5} y2={p.y+5} stroke={color} strokeWidth="1.8" />
        <line x1={p.x-5} y1={p.y+5} x2={p.x+5} y2={p.y-5} stroke={color} strokeWidth="1.8" />
      </g>
    );
  }
  return (
    <g>
      <circle cx={p.x} cy={p.y} r="6" fill={c.dotFill} stroke={color} strokeWidth="1.5" />
      <text x={p.x} y={p.y+2} textAnchor="middle" fontSize="6" fontWeight="700"
            fill={color} fontFamily="'Barlow Condensed', sans-serif">
        {p.label || (OFFENSE_KINDS.includes(p.kind) ? p.kind : "")}
      </text>
    </g>
  );
}

function RoutePath({ r, positions, c }) {
  const from = positions.find(p => p.id === r.from_id);
  if (!from) return null;
  const d = [{ x: from.x, y: from.y }, ...r.points]
    .map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");
  return <path d={d} stroke={c.route} strokeWidth="2.5" fill="none" markerEnd={`url(#${c.marker})`} />;
}

export default function DiagramView({ diagram, className = "", printMode = false }) {
  if (!diagram || (!diagram.positions?.length && !diagram.routes?.length)) return null;
  const c = palette(printMode);
  const positions = diagram.positions || [];

  return (
    <svg viewBox="0 0 500 300" className={className}
         style={{ aspectRatio: "5 / 3", background: c.field, display: "block" }}>
      <defs>
        <marker id={c.marker} viewBox="0 0 10 10" refX="9" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse">
          <path d="M 0 0 L 10 5 L 0 10 z" fill={c.route} />
        </marker>
      </defs>
      {YARD_LINES.map(x => (
        <line key={`yard-${x}`} x1={x} y1="10" x2={x} y2="290" stroke={c.yard} strokeWidth="1" />
      ))}
      <line x1="10" y1="10" x2="490" y2="10" stroke={c.sideline} strokeOpacity={c.sidelineOpacity} strokeWidth="1.5" />
      <line x1="10" y1="290" x2="490" y2="290" stroke={c.sideline} strokeOpacity={c.sidelineOpacity} strokeWidth="1.5" />
      <line x1="10" y1="150" x2="490" y2="150" stroke={c.los} strokeOpacity={0.7} strokeWidth="1.5" strokeDasharray="6 4" />
      {diagram.routes?.map(r => <RoutePath key={r.id} r={r} positions={positions} c={c} />)}
      {positions.map(p => <PositionMark key={p.id} p={p} c={c} />)}
    </svg>
  );
}
